export default __webpack_public_path__ + "static/media/fu.7838658e.jpg";